export enum ActionType {
  MANPOWER_DETAILS_BY_PID = "MANPOWER_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IManpowerCostByPid {
  type: ActionType.MANPOWER_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IManpowerCostByPid | IResetReduxState;
